import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=80f595de&scoped=true&"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseOrder.vue?vue&type=style&index=0&id=80f595de&prod&lang=scss&scoped=true&"
import style1 from "./CreatePurchaseOrder.vue?vue&type=style&index=1&id=80f595de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f595de",
  null
  
)

export default component.exports